angular.module('siter.io').factory 'TplCache', ["$templateCache", "$http", ($templateCache, $http) ->
  cache =
    get: (url) ->
      $http.get(url)
        .success (data, status, headers, config) ->
          $templateCache.put url, data
  cache
]



// WEBPACK FOOTER //
// ./src/app/common/services/cache.service.coffee